import { Autocomplete, Box, Checkbox, Stack, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CheckIcon from '@mui/icons-material/Check';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { Color, FontStyle, defaultBottomPadding, defaultInnerStyle, defaultContainerStyle } from '../../constants';
import CheckButton, { CheckButtonStack } from '../CheckButton';
import HeartButton from '../HeartButton'
import TempDisplay from '../TempDisplay';
import { CustomPaper, StyledTextField } from '../AutocompleteUtils';


const styles = {
  container: {
    ...defaultContainerStyle,
  },
  inner: {
    ...defaultInnerStyle,
    // padding: '1rem',
    borderRadius: '0.75rem',
    // border: '2px solid rgb(162, 162, 146)',
    cursor: 'pointer',
    maxWidth: '500px',
  },
  subtitle: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'center',
  },
  title: {
    ...FontStyle.headingBody,
    fontSize: '1rem',
    lineHeight: 1.3,
  },
  link: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'center',
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'black',
  },
  body: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'left',
    lineHeight: '1.4',
    maxWidth: '500px',
    '& > * >a': {
      color: '#000',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      }
    }
  },
  label: {
    ...FontStyle.headingBody,
    fontSize: '1rem',
    // textAlign: 'center',
    lineHeight: '1.4',
    width: '100%',
    maxWidth: '500px',
  },
  search: {
    width: '100%',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: '4px',
    border: '1px solid rgb(204, 204, 204)',
  },
  searchProps: {
    disableUnderline: true,
  },
  info: {
    borderLeft: `6px solid ${Color.primary}`,
    borderRadius: '0.75rem',
    backgroundColor: '#fff',
    padding: '1.2rem',
  }
}

const selectionData = [
  {
    title: 'Daily',
    bullets: [
      {
        icon: '🔔',
        iconTransform: 'translateY(3.3px)',
        // text: 'Apply to jobs soon after they are advertized. We typically see the most applications in the first 3 days'
        text: 'Discover & apply to new jobs right after they\’re listed'
      },
      {
        icon: '🔒',
        // text: 'Our most active users are emailed daily'
        text: 'Lock in that dream job by applying early'
      },
      {
        icon: '💸',
        // text: 'Our most active users are emailed daily'
        text: 'Apply to new listings within the first 3 days to maximize your chances!'
      },
    ],
  },
  {
    title: 'Weekly',
    bullets: [
      {
        icon: '🔔',
        text: 'I\'d like to receive weekly emails with the latest job opportunities.'
      }]
  },
  {
    title: 'Never',
    bullets: [
      {
        icon: '🔕',
        text: "I am not interested in receiving emails about the latest job opportunities."
      }]
  }
]



const Q16_Emails = ({ selected, setSelected, setQuestionsDone, questionNum, options }) => {
  useEffect(() => {
    setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
  }, [selected])
  const [period, setPeriod] = useState(1)
  useEffect(() => {
    setSelected(s => { return { ...s, [questionNum]: [period] } })
  }, [period])
  return (
    <Stack direction='column' sx={styles.container} alignItems='center' spacing={2}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack direction='column' alignItems='center' spacing={1} sx={{ ...styles.inner }}>
        {selectionData.map(({ title, bullets }, index) => {
          return (
            <>
              <CheckButtonStack key={'check' + index}
                data={{ title, bullets }}
                selected={period === index}
                setSelected={() => setPeriod(index)}
                extraHoverStyle={index === 0 ? 'greenHover' : index === 2 ? 'noHover' : ''}
              />
              {/* <Stack direction='column' key={index} sx={{ ...styles.inner, backgroundColor: period === index ? Color.primary : '#fff' }}
              onClick={() => setPeriod(index)}
              spacing={1}
            >
              <Box sx={styles.title}>{title}</Box>
              {bullets.map((bullet, index) => {
                return (<Stack key={index} alignItems='flex-start' direction='row' sx={{ ...styles.body, textAlign: 'left', width: '100%' }}>
                  <Box sx={{ minWidth: '30px' }}>
                    <CheckIcon sx={{ width: '20px' }} />
                  </Box>{bullet}</Stack>
                )
              })}
            </Stack> */}
            </>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default Q16_Emails